import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { useLanguage } from './LanguageContext';
import { TrendingDown, LineChart, Activity } from 'lucide-react';
interface SlideAIOpportunityProps {
  onContinue: () => void;
}
export function SlideAIOpportunity({
  onContinue
}: SlideAIOpportunityProps) {
  const {
    t
  } = useLanguage();
  const [stage, setStage] = useState(0);
  const levers = [{
    id: 'erosion',
    title: t('Reduce Erosion', 'Reducer erosion'),
    desc: t('Continuous, data-driven engagement keeps HCPs connected to the brand — actively defending market share instead of letting it fade.', "Kontinuerligt, datadrevet engagement holder HCP'er forbundet til brandet — og forsvarer aktivt markedsandele i stedet for at lade dem falme."),
    icon: <TrendingDown className="w-6 h-6 text-teal-400" data-id="element-176" />,
    color: 'from-teal-400/20 to-teal-400/5',
    borderColor: 'border-teal-400/30'
  }, {
    id: 'profitability',
    title: t('Increase Profitability', 'Øg rentabiliteten'),
    desc: t('Replacing traditional marketing with AI-automated execution widens the margin on every euro of legacy revenue.', 'Udskiftning af traditionel markedsføring med AI-automatiseret eksekvering udvider marginen på hver euro af legacy-omsætning.'),
    icon: <LineChart className="w-6 h-6 text-purple-400" data-id="element-177" />,
    color: 'from-purple-500/20 to-purple-500/5',
    borderColor: 'border-purple-500/30'
  }, {
    id: 'lifespan',
    title: t('Prolong Lifespan', 'Forlæng levetiden'),
    desc: t('Lower costs and slower erosion keep the gap between revenue and cost positive for longer, keeping products on market.', 'Lavere omkostninger og langsommere erosion holder kløften mellem omsætning og omkostninger positiv i længere tid, hvilket holder produkter på markedet.'),
    icon: <Activity className="w-6 h-6 text-rose-400" data-id="element-178" />,
    color: 'from-rose-400/20 to-rose-400/5',
    borderColor: 'border-rose-400/30'
  }];
  useEffect(() => {
    const timers = levers.map((_, idx) => setTimeout(() => setStage(idx), 600 + idx * 800));
    return () => timers.forEach(clearTimeout);
  }, []);
  return <div className="h-full w-full flex flex-col px-8 py-10 md:px-20 md:py-14 max-w-7xl mx-auto" data-id="element-179">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="text-center space-y-4" data-id="element-180">
        <h2 className="text-4xl md:text-5xl font-serif text-white" data-id="element-181">
          {t('Three Levers', 'Tre håndtag')}
        </h2>
        <p className="text-xl text-white/60" data-id="element-182">
          {t('How we compound value across the legacy portfolio.', 'Hvordan vi akkumulerer værdi på tværs af legacy-porteføljen.')}
        </p>
      </motion.div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: stage >= 4 ? 1 : 0
    }} className="mt-12 flex justify-center" data-id="element-183">
        <Button onClick={onContinue} data-id="element-184">
          {t('Operating Model', 'Driftsmodel')}
        </Button>
      </motion.div>
    </div>;
}